import { render, staticRenderFns } from "./ListaNotificacoes.vue?vue&type=template&id=225133fa&scoped=true&"
import script from "./ListaNotificacoes.vue?vue&type=script&lang=js&"
export * from "./ListaNotificacoes.vue?vue&type=script&lang=js&"
import style0 from "./ListaNotificacoes.vue?vue&type=style&index=0&id=225133fa&scoped=true&lang=css&"
import style1 from "./ListaNotificacoes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225133fa",
  null
  
)

export default component.exports